<template>
  <div class="page">
    <div>
        <ion-grid fixed>
            <ion-row class="rectangle">
                <ion-col>
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="3">
                            <ion-label>Select Dashboard</ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-select
                                    class="form-select select-mobile"
                                    :value="chartName"
                                    @ionChange="selectDashboardChart($event)"
                                    placeholder="Select Dashboard"
                                    interface="action-sheet"
                                    :disabled = "displaySelectDashboard"
                                >
                                    <ion-select-option
                                    v-for="(chart, index) in this.chartTypes"
                                    :key="index"
                                    :value="chart.name"
                                    >{{chart.name}}</ion-select-option>
                                </ion-select>

                                <select
                                    @change="selectDashboardChart($event)"
                                    class="input-select select-web"
                                    v-model="chartName"
                                    placeholder="Select Status"
                                    :disabled = "displaySelectDashboard"
                                >
                                    <option
                                    v-for="(chart, index) in this.chartTypes"
                                    :key="index"
                                    :value="chart.name"
                                    >{{ chart.name }}</option>
                                </select>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label>Select Branch</ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-select
                                    class="form-select select-mobile"
                                    :value="branchId"
                                    @ionChange="changeBranchName($event)"
                                    placeholder="Select Dashboard"
                                    interface="action-sheet"
                                >
                                    <ion-select-option
                                     v-for="(branchInfo, index) in this.branchList"
                                    :key="index"
                                   :value="branchInfo.branchId"
                                    >{{branchInfo.corporateName}}, {{ branchInfo.branch }}</ion-select-option>
                                </ion-select>

                                <select
                                     @change="changeBranchName($event)"
                                    class="input-select select-web"
                                    v-model="branchId"
                                    placeholder="Select Status"
                                >
                                    <option
                                    v-for="(branchInfo, index) in this.branchList"
                                    :key="index"
                                    :value="branchInfo.branchId"
                                    >{{branchInfo.corporateName}}, {{ branchInfo.branch }}</option>
                                </select>
                            </div>
                        </ion-col>
                        <!-- <ion-col size="12" size-md="2">
                            <ion-label>Branch ID</ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input
                                class="form-input"
                                type="text"
                                id="branchId"
                                @input="branchId = $event.target.value"
                                maxlength="50"
                                placeholder="Branch ID"
                                :value = branchId
                                ></ion-input>
                            </div>
                        </ion-col> -->
                        <ion-col size="12" size-md="2">
                            <br />
                            <!-- <ion-button class="btn-search margin-top-10" @click="searchBranches">Search</ion-button> -->
                            <ion-button class="btn-clear margin-top-10" @click="clearFilter">
                                <ion-icon :icon="refresh"></ion-icon>
                            </ion-button>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
    <div class="spinner">
        <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
    <div v-if="loadChargerStausChart">
        <ChargerStatusDasboard :chartData="chargerStatusData"/>
    </div>
    <div v-if="loadConsumedEnergeyChart">
        <EnergyConsumedDashboard :consumeEnergyData="greenHousGasData"/>
    </div>
    <div v-if="!noStationAssociatedInd && !displayInd">
      <ion-grid>
          <ion-row class="rectangle">
              <ion-col>
                  <p class="noAssociatedStations"  style="text-align: center;">No Associated Stations</p>
              </ion-col>
          </ion-row>
      </ion-grid>
    </div>
    <div v-if="noStationAssociatedInd && !displayInd">
      <ion-grid>
          <ion-row class="rectangle">
              <ion-col>
                  <p class="noAssociatedStations"  style="text-align: center;">No data to display</p>
              </ion-col>
          </ion-row>
      </ion-grid>
    </div>
<!--     
    <div class="spinner">
        <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
    <div v-if="loadChargerStausChart">
        <ChargerStatusDasboard :chartData="chargerStatusData"/>
    </div>
    <div v-if="loadConsumedEnergeyChart">
        <EnergyConsumedDashboard :consumeEnergyData="greenHousGasData"/>
    </div>
    <div v-if="!noStationAssociatedInd && !displayInd">
        <ion-grid>
            <ion-row class="rectangle">
                <ion-col>
                    <p class="noAssociatedStations"  style="text-align: center;">No Associated Stations</p>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
    <div v-if="noDataForEnergy">
        <ion-grid>
            <ion-row class="rectangle">
                <ion-col>
                    <p class="noStations1"  style="text-align: center;" >No data for input criteria</p>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div> -->
  </div>
</template>


<script>
import { defineComponent } from "vue";

import Chart from "chart.js/auto";
import { CorporateService } from "../../service/corporate/corporate.service";
import CPOChargerStatusDashboard from "./CPOChargerStatusDashboard.vue";
import CPOEnergyConsumedDashboard from "./CPOEnergyConsumedDashboard.vue";
import { IonCol, IonGrid, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import { ToastUtils } from "../../util/toast-utils";
import { migratedTryParseServiceError } from "../../service";
import { refresh } from "ionicons/icons";
import ChargerStatusDasboard from "../admin/ChargerStatusDashboard.vue"
import EnergyConsumedDashboard from "../admin/EnergyConsumedDashboard.vue"

export default defineComponent ({
  name: 'cpoAdminDashboard',
  components: {
    CPOChargerStatusDashboard, CPOEnergyConsumedDashboard, Chart, IonGrid, IonRow, IonCol, IonLabel, IonSelect, 
    IonSelectOption,IonSpinner, ChargerStatusDasboard,
    EnergyConsumedDashboard
  },
  data() {
    return {
      refresh,
      segment: "dashboard",
      widowWidth: "",
      doughnutStyle: "position: relative; height:40vh; width:80vw",
      chartInfo: [],
      branchName: "",
      chartValue: [],
      chartLabel: [],
      chartPlugin: "",
      myChart: null,
      mixedMyChart: null,
      chartTypes: [{'code': 'CS', 'name' : 'Charger Status'},{'code': 'CAD','name' : "CPO Admin Dashboard"}],
      chartName: "",
      chartTypeInd: true,
      doughnutChartInd: true,
      mixedChartInd: false,
      actualValue: [],
      baselineValue: [],
      co2IndValue: [],
      usageMonth: [],
      branchList: [],
      // 
      loaderTab: false,
      chargerStatus: "",
      co2IndexUsage: "",
      chargerStatusData: [],
      greenHousGasData: [],
      loadChargerStausChart: false,
      branchId: "",
      noStationAssociatedInd: false,
      displayInd: true,
      displayChargerStatus: false,
      loadConsumedEnergeyChart: false,
      displaySelectDashboard: true
    }
  },
  async mounted() {
    this.chartName = this.chartTypes[0].name;
    this.getBranchListForChart();
  },
  methods: {
  
    async getBranchListForChart() {
      this.branchList = [];
      this.loaderTab = true;
      try {
        this.branchList =  await new CorporateService().getBranchList();
        this.branchId = this.branchList[0].branchId;
        this.loaderTab = false;
        this.getChargerStatus(this.branchId);
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },
    selectDashboardChart(event) {
      this.chartName = event.target.value;
      localStorage.setItem('branchId', this.branchId)
       if(this.chartName == "Charger Status") {
        this.loadConsumedEnergeyChart = false;
        // this.getBranchListForChart();
        this.displaySelectDashboard = true;
        this.getChargerStatus(this.branchId);
        
      } else {
        this.loadChargerStausChart = false;
        this.displaySelectDashboard = true;
        this.getConsumedEnergeyChart(this.branchId);         
      }
    },
    async changeBranchName(event) {
      
      this.branchId = event.target.value;
      localStorage.setItem('branchId', this.branchId)
      if(this.chartName == "Charger Status") {
        this.getChargerStatus(this.branchId);
      } else {
        this.getConsumedEnergeyChart(this.branchId)
      }
      
    },
    async getChargerStatus(branchId) {
      this.loaderTab = true;
      this.loadChargerStausChart = false;
      if(branchId != 'All') {
        try {
          this.chargerStatusData = await new CorporateService().getBranchChargerStatus(branchId);
          if(this.chargerStatusData.displayData.totalCount > 0) {
            this.loadChargerStausChart = true;
            this.displayChargerStatus = true;
            this.displayInd = true;
            // localStorage.removeItem('branchInfoForDashboard');
            this.loaderTab = false;
          } else {
            this.displayInd = false;
            this.noStationAssociatedInd = false;
          }
          this.loaderTab = false;
          this.displaySelectDashboard = false;
        } catch(error) {
          this.loaderTab = false;
          this.displaySelectDashboard = false;
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
        }
      } else {
        try {
          this.chargerStatusData = await new CorporateService().getOverAllBranchChargerStatus();
          if(this.chargerStatusData.displayData.totalCount > 0) {
            this.loadChargerStausChart = true;
            this.displayChargerStatus = true;
            this.displayInd = true;
            // localStorage.removeItem('branchInfoForDashboard');
          } else {
            this.displayInd = false;
            this.noStationAssociatedInd = false;
          }
          this.loaderTab = false;
          this.displaySelectDashboard = false;
        } catch(error) {
          this.loaderTab = false;
          this.displaySelectDashboard = false;
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
        }
      }
    },
    async getConsumedEnergeyChart(branchId) {
      this.loaderTab = true;
      this.loadChargerStausChart = false;
      if(branchId != 'All') {
        try {
          this.greenHousGasData = await new CorporateService().getConsumedEnergeyChartDataForCPO(branchId);
          if(this.greenHousGasData.displayChart) {
            this.loadConsumedEnergeyChart = true;
            this.displayChargerStatus = false;
            this.displayInd = true;
            this.loaderTab = false;
          } else {
            this.displayInd = false;
            this.noStationAssociatedInd = true;
          }
          this.loaderTab = false;
          this.displaySelectDashboard = false;
        } catch(error) {
          this.displaySelectDashboard = false;
          this.loaderTab = false;
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
        }
      } else {
        try {
          let id = '';
          this.chargerStatusData = await new CorporateService().getConsumedEnergeyChartDataForCPO(id);
          // if(this.greenHousGasData.displayChart) {
            if(branchId != 'All') {
            this.loadConsumedEnergeyChart = true;
            this.displayChargerStatus = false;
          } else {
            this.displayInd = false;
            this.noStationAssociatedInd = true;
          }
          this.loaderTab = false;
          this.displaySelectDashboard = false;
        } catch(error) {
          this.loaderTab = false;
          this.displaySelectDashboard = false;
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
        }
      }
    },
    clearFilter() {
      // alert(this.chartName)
      // alert(this.branchId)
      // this.branchId = ""
      this.loadConsumedEnergeyChart = false;
      this.loadChargerStausChart = false;
      if(this.chartName == "Charger Status") {
        this.loadConsumedEnergeyChart = false;
        this.displaySelectDashboard = true;
        this.getChargerStatus(this.branchId);
        
      } else {
        this.loadChargerStausChart = false;
        this.displaySelectDashboard = true;
        this.getConsumedEnergeyChart(this.branchId);         
      }
    }
   
  }
})
</script>